/**
 * Vertical do item da negociação (val1, 28/10; crm8, 29/10): regras puras da escolha "vertical primeiro, catálogo filtrado" que o CRM
 * novo (aba Produtos) e a tela antiga (itens da oportunidade) compartilham.
 */

/** V3 verticais: o serviço é oferecido na vertical (marcado nela ou em "Todas"); sem vertical escolhida, qualquer um. */
export const ofereceNa = (servico: { empresas?: string[] }, vertical: string) => !vertical || !servico.empresas?.length || servico.empresas.includes(vertical);

/** O catálogo de venda restrito à vertical escolhida (o serviço de "Todas" aparece em toda vertical). */
export const servicosDaVertical = <T extends { empresas?: string[] }>(servicos: readonly T[], vertical: string): T[] => servicos.filter((s) => ofereceNa(s, vertical));

export interface MarcacaoDaNegociacao {
  empresas: string[];
  todas: boolean;
}

/**
 * As verticais que o item pode ter. 29/10 (crm8, item 2a): as marcadas para o lead, isto é, a negociação ou a empresa dela
 * (a união das duas; "Todas" não restringe e, com as duas em "Todas", valem todas as visíveis). Só uma possível: ela já vem
 * escolhida. A da empresa que a negociação ainda não tem é "nova": o servidor a acrescenta à negociação ao salvar.
 * Quem vê uma empresa só não escolhe (o servidor completa). Marcação nula = ainda carregando; a da empresa com erro (sem permissão no Cadastros) conta como "Todas".
 */
export function verticaisDoItem<E extends { id: string }>(visiveis: readonly E[], negociacao: MarcacaoDaNegociacao | null | undefined, empresa: MarcacaoDaNegociacao | null | undefined) {
  const pronto = visiveis.length <= 1 || (!!negociacao && !!empresa);
  if (!pronto || visiveis.length <= 1) return { pronto, visiveis: [...visiveis], opcoes: [] as E[], unica: null as E | null, nova: (_id: string) => false };
  const marcadas = [...(negociacao!.todas ? [] : negociacao!.empresas), ...(empresa!.todas ? [] : empresa!.empresas)];
  const opcoes = marcadas.length ? marcadas.flatMap((id, n) => (marcadas.indexOf(id) === n ? visiveis.filter((e) => e.id === id) : [])) : [...visiveis];
  const nova = (id: string) => !negociacao!.todas && !!id && opcoes.some((e) => e.id === id) && !negociacao!.empresas.includes(id);
  return { pronto, visiveis: [...visiveis], opcoes, unica: opcoes.length === 1 ? opcoes[0]! : null, nova };
}
